<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/localizacao"> Cadastro/Localizacoes </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Nome *"
              v-model="nome"
              :counter="200"
              :rules="[(v) => !!v || 'O Nome é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/localizacao" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarLocalizacaoAsync } from "../../../services/localizacaoService";
import { mapState } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroUsuario";

export default {
  name: "criarLocalizacao",
  data: () => ({
    overlay: false,
    valid: true,
    nome: null,
    active_tab:2
  }),
  computed: {
    ...mapState("localizacao", ["localizacoes"]),
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarLocalizacaoAsync(this.nome);
        if (resposta) {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/localizacao");
        }
      }
    },
  },
};
</script>
